import CryptoJS from 'crypto-js'
import NodeRSA from 'node-rsa'
import pako from 'pako'

const SHA256Key = 'kcvc6cb509rtye898dd48feecba965e0'
const REAPublicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6D4CRIl6AWxOS4Pq2l7nRCNw0nCIo9l4UdbbV5h5CkL57dVjT0sDSt3DpuqUyFZnsLiQ8apy2JmmFSFISpwXW4AReBgehiLP+rivkp2DqJDE/DQTagEerlhSUZm7wgzwXBVR0U9caT7EeFso0/Laz9/gVL1ufRh++HM7Zwe2UZwIDAQAB
-----END PUBLIC KEY-----
`

/* 公钥加密发给后端 */
export function encryptToString(
  params: Record<string, unknown> = {},
  SHAKey: string = SHA256Key,
  REAKey: string = REAPublicKey
): string {
  // 将对象数据进行整理
  const paramsArr = Object.entries(params)
    .map(([key, value]) => ({
      key,
      value: typeof value === 'object' ? JSON.stringify(value) : value
    }))
    .filter(
      ({ value }) =>
        value !== '' &&
        value !== null &&
        value !== undefined &&
        value !== 'null'
    )
    .sort((a, b) => a.key.localeCompare(b.key))

  // 转成 URL 参数字符串
  const paramsStr = paramsArr
    .map(({ key, value }) => `${key}=${value}`)
    .join('&')

  // 使用掩码进行加密
  const encryptedHmac = CryptoJS.HmacSHA256(paramsStr, SHAKey).toString()

  // 使用 RSA 进行加密
  const PK = new NodeRSA(REAKey)
  PK.setOptions({ encryptionScheme: 'pkcs1' })
  // 加密输出为 Base64 字符串
  const encryptedRSA = PK.encrypt(encryptedHmac, 'base64')

  return encryptedRSA
}

/* 解密后端返回的密文 */
export function decryptToJSON(encryptedStr: string): object | null {
  if (typeof encryptedStr !== 'string' || encryptedStr.includes('Error')) {
    console.log('输入不是字符串或包含错误信息。🚫')
    return null
  }

  const key = CryptoJS.enc.Utf8.parse('56jh5jsk98888888')
  const iv = CryptoJS.enc.Utf8.parse('6a508f8a81314c65')

  try {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedStr, key, {
      mode: CryptoJS.mode.CBC,
      iv
    })

    // 直接将解密后的数据转换为 Utf8 字符串
    const utf8Str = decryptedBytes.toString(CryptoJS.enc.Utf8)

    // 解码 Base64 字符串转换为二进制字符串
    const binaryStr = atob(utf8Str)

    // 使用 Array.from 将二进制字符串转换为 Uint8Array
    const bytes = new Uint8Array(Array.from(binaryStr, (c) => c.charCodeAt(0)))

    // 使用 pako.inflate 进行解压缩
    const decompressed = pako.inflate(bytes, { to: 'string' })

    // 解析JSON
    return JSON.parse(decompressed)
  } catch (e) {
    console.error('解密或解析过程中出现错误：', e)
    return null
  }
}

/* 设置简单的加密给到 RS */
const secretKey = 'reelshort-web-password'
export const encryptedToRS = (value: any) => {
  const _value = typeof value === 'object' ? JSON.stringify(value) : value
  try {
    // 使用 AES 加密数据
    const encryptedValue = CryptoJS.AES.encrypt(_value, secretKey).toString()
    return encryptedValue
  } catch (error) {
    console.error('Error setting encrypted item:', error)
    return null
  }
}
